import { cn } from '@tripleten/cn';

export const cnCheckbox = cn('kc-checkbox');
